import { Sparkles } from 'lucide-react';

interface Props {
  streaming: boolean;
}

const SPARKS = [
  { x: -8, y: -9, delay: 0, size: 3 },
  { x: 8, y: -8, delay: 0.15, size: 2 },
  { x: 10, y: 6, delay: 0.3, size: 2.5 },
  { x: -9, y: 7, delay: 0.45, size: 2 },
  { x: 0, y: -11, delay: 0.6, size: 1.5 },
];

export function AiSparkleIcon({ streaming }: Props) {
  return (
    <span className='relative flex items-center justify-center'>
      <span
        className='flex'
        style={
          streaming
            ? { animation: 'ai-sparkle-pulse 1.8s ease-in-out infinite' }
            : undefined
        }
      >
        <Sparkles size={14} />
      </span>

      {streaming &&
        SPARKS.map((s, i) => (
          <span
            key={i}
            className='absolute rounded-full pointer-events-none'
            style={
              {
                width: s.size,
                height: s.size,
                background: 'var(--color-ai)',
                boxShadow: '0 0 4px 1px var(--color-ai)',
                '--sx': `${s.x}px`,
                '--sy': `${s.y}px`,
                animation: `ai-spark-float 1.4s ease-out ${s.delay}s infinite`,
                animationDelay: `${s.delay}s`,
              } as React.CSSProperties
            }
          />
        ))}
    </span>
  );
}
